import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { resetPasswordSelector } from 'src/store/auth';

import { CustomButton, WhiteCard } from 'src/components';

import { ROUTE } from 'src/constants';

import { SuccessIcon } from 'src/assets';
import './forgotPasswordSuccess.scss';

export const ForgotPasswordSuccess = () => {
  const { t } = useTranslation('forgotPassword');

  const navigate = useNavigate();

  const resetPasswordMessage = useSelector(resetPasswordSelector);

  useEffect(() => {
    if (!resetPasswordMessage) {
      navigate(ROUTE.AUTH.FORGOT_PASSWORD);
    }
  }, [navigate, resetPasswordMessage]);

  const onClickSubmit = useCallback(
    (event) => {
      event.preventDefault();

      navigate(ROUTE.AUTH.SIGN_IN);
    },
    [navigate],
  );

  return (
    <div className="forgot-password-success">
      <WhiteCard>
        <h2>{t('passwordReset')}</h2>
        <img src={SuccessIcon} alt={SuccessIcon} />
        <h4>{t('resetSuccess')}</h4>
        <form className="forgot-password-success__form">
          <CustomButton title={t('title:ok')} variant="filled" onClick={onClickSubmit} />
        </form>
      </WhiteCard>
    </div>
  );
};
